// 需要全局注册的组件写到这里
import Vue from 'vue'

const $components = {
  // 在这里注入引入的组件 Component,
}
const components = {}

Object.keys($components).forEach(key => {
  components[key] = Vue.component(key, $components[key])
})

export default components
